module.exports = __webpack_public_path__ + "static/media/A11.16040ce3.jpg";